import React from 'react';
import ExcalmationSvg from './ExcalmationSvg';

const ImplementationMethodTooltip = () => {
  return (
    <div className="reactions-implementation-title-baloon-container">
      <div className="info-svg">
        <ExcalmationSvg />
        <div className="reactions-implementation-title-baloon-content">
          <p>
            <strong>Default (Related Keyword)</strong> - automatically assigns Reaction Sets
            according to related keywords.
          </p>
          <p>
            <strong>Manual Code Integration (Theme)</strong> - manually connect Reaction Sets based
            on Theme.
          </p>
        </div>
      </div>
    </div>
  );
};

const ImplementationTitle = () => (
  <div style={{ display: 'flex' }}>
    <span>Implementation Method</span>
    <ImplementationMethodTooltip />
  </div>
);

export default ImplementationTitle;
